import useStore from "../AppStore"

export default function LangSwitch(props) {
  const lang = useStore(state => state.lang)
  return (
    <div className="language-switch">
      <span className={`lang ${lang == 1 && 'active'}`} onClick={()=>useStore.setState({lang: 1})}>PT</span>
      <span className={`lang ${lang == 0 && 'active'}`} onClick={()=>useStore.setState({lang: 0})}>EN</span>
    </div>
  )
}